module.exports = __webpack_public_path__ + "29dd199cb7bed8a5ba1215bb7192d54e.svg";